import { createAdminSlice } from "../components/Admin/adminSlice";
import { create } from "zustand";

const useStore = create((...a) => ({
  ...createAdminSlice(...a),
}));

export default useStore;
